<template>
  <VDialog
    ref="dialog"
    :opener="props.opener"
    @dismiss="emit('closeModal', $event)"
    :hidden="isBanksTermsAndConditionModalVisible"
    aria-describedby="add-bank"
  >
    <gsp-dialog-header close="false">
      <div class="heading-loader">
        <h2 v-t="'labels.addBankHeading'" id="add-bank" />
        <VLoader class="vm-ml-4" v-if="isLoading" />
      </div>
    </gsp-dialog-header>
    <gsp-dialog-body>
      <VDialogCloseButton @click="dialog.emitDismiss" />
      <div class="vm-mb-6">
        <label class="default" v-t="'labels.accountOwner'" />
        <div class="vm-pls-typo-dt-gsp-design-h4">
          {{ props.customerProfileName }}
        </div>
      </div>
      <VTextField
        v-model="data.bankMicrIdentifier"
        schema-field="routingNumber"
        class="vm-mb-1"
        maxlength="9"
      >
        <span class="vm-flex-1"
          ><span v-t="'labels.routingNumber'" class="vm-mr-1" /> (<span
            v-t="'labels.required'"
            class="vm-font-normal"
          />)</span
        ><template #position-start>
          <gsp-icon
            :id="instanceId + '-routing-number'"
            class="info-position"
            :aria-label="t('labels.routeNumberStatementAriaLabel')"
            tabindex="0"
            role="img"
            >circle-info</gsp-icon
          >
        </template>
      </VTextField>
      <VTooltip
        class="w-dialog"
        :anchor="instanceId + '-routing-number'"
        auto-update-mode="auto"
        position="bottom-left"
        tabindex="0"
      >
        <p v-html-t="'htmlMarkup.routeNumberStatement'" class="vm-mb-4" />
        <img src="@/assets/images/check-info.png" class="vm-w-full" alt="" />
      </VTooltip>
      <VTextField
        v-model="data.bankAccountNumber"
        schema-field="accountNumber"
        class="vm-mb-1"
        :minlength="testRoutingNumber == data.bankMicrIdentifier ? '1' : '4'"
        maxlength="17"
      >
        <span class="vm-flex-1"
          ><span v-t="'labels.accountNumber'" class="vm-mr-1" /> (<span
            v-t="'labels.required'"
            class="vm-font-normal"
          />)</span
        ><template #position-start>
          <gsp-icon
            :id="instanceId + '-account-number'"
            class="info-position"
            :aria-label="t('labels.accountNumberStatementAriaLabel')"
            tabindex="0"
            role="img"
            >circle-info</gsp-icon
          >
        </template>
      </VTextField>
      <VTooltip
        class="w-dialog"
        :anchor="instanceId + '-account-number'"
        auto-update-mode="auto"
        position="bottom-left"
      >
        <p v-html-t="'htmlMarkup.accountNumberStatement'" class="vm-mb-4" />
        <img src="@/assets/images/check-info.png" class="vm-w-full" alt="" />
      </VTooltip>
      <VSelect v-model="data.bankAccountTypeCode" schema-field="accountType">
        <template #label>
          <span v-t="'labels.accountType'" class="vm-mr-1" /> (<span
            v-t="'labels.required'"
            class="vm-font-normal"
          />)</template
        >
        <gsp-option v-t="'labels.checking'" value="C"></gsp-option>
        <gsp-option v-t="'labels.savings'" value="S"></gsp-option>
      </VSelect>
      <gsp-divider class="vm-mt-5 vm-mb-8" />
      <VSelect
        v-model="data.payeeRecipientEntityCode"
        schema-field="registrationType"
        class="vm-mb-1"
        @change="registrationTypeChanged"
      >
        <template #label
          ><span v-t="'labels.registrationType'" class="vm-mr-1" /> (<span
            v-t="'labels.required'"
            class="vm-font-normal"
          />)</template
        >
        <gsp-option v-t="'labels.individual'" value="N"></gsp-option>
        <gsp-option v-t="'labels.entity'" value="Y"></gsp-option>
      </VSelect>
      <div v-show="data.payeeRecipientEntityCode == 'N'">
        <RegistrationName
          v-model="data"
          :config="registerationNameFormConfig.primary"
        />
        <RegistrationName
          v-model="data"
          :config="registerationNameFormConfig.secondary"
          v-show="addAnotherRegestrationField"
        />
        <gsp-primary-anchor
          v-if="!addAnotherRegestrationField"
          class="vm-mb-8"
          @click="addAnotherRegestrationField = true"
          href="javascript:void(0)"
          tabindex="0"
        >
          <gsp-icon slot="start" aria-hidden="true">circle-plus</gsp-icon>
          <span v-t="'labels.addAnotherRegistrationName'" />
        </gsp-primary-anchor>
      </div>
      <VTextField
        v-show="data.payeeRecipientEntityCode == 'Y'"
        v-model="data.firstPayeeRecipientLastName"
        schema-field="entityName"
        minlength="2"
        maxlength="35"
      >
        <span v-t="'labels.entityName'" class="vm-mr-1" />(<span
          v-t="'labels.required'"
          class="vm-font-normal"
        />)
      </VTextField>
      <div class="vm-flex">
        <gsp-checkbox
          :checked="bankAuthTermsAndCondition"
          @change="bankAuthTermsAndCondition = $event.target.checked"
          required
          :aria-label="t('labels.bankTermsAndConditionsAriaLabel')"
        >
        </gsp-checkbox>
        <VTRuntimeTemplate
          template-t="htmlMarkup.bankTermsAndConditions"
          :template-props="{
            termsAndConditionsRefFn,
            showBanksTermsAndConditionModal,
          }"
        />
      </div>
      <gsp-checkbox
        :checked="acknowledgeRedemption"
        @change="acknowledgeRedemption = $event.target.checked"
        class="vm-pt-5"
        required
      >
        <span v-html-t="'htmlMarkup.redemptionAknowledge'" />
      </gsp-checkbox>
    </gsp-dialog-body>
    <gsp-dialog-footer>
      <div class="btn-wrapper reverse">
        <gsp-primary-button
          @click="submitClicked"
          :disabled="
            userProfileDetailsStore.getters.isOperator ||
            !isFormValid ||
            disableSubmit
          "
          v-t="'labels.addBankSubmit'"
          class="gsp-primary-button-default"
        />
        <gsp-tertiary-button
          class="vm-mr-8"
          @click="dialog.emitDismiss"
          v-t="'labels.cancel'"
        />
      </div>
    </gsp-dialog-footer>
  </VDialog>
  <BanksTermsAndConditionsModal
    v-if="isBanksTermsAndConditionModalVisible"
    opener="termsAndConditionsLinkRef"
    @close-modal="isBanksTermsAndConditionModalVisible = false"
  />
</template>

<script>
let instanceCount = 0;

const defaultRegisterationNameData = {
  firstPayeeRecipientFirstName: "",
  firstPayeeRecipientMiddleInitial: "",
  firstPayeeRecipientLastName: "",
  firstPayeeRecipientSuffix: "",
  secondPayeeRecipientFirstName: "",
  secondPayeeRecipientMiddleInitial: "",
  secondPayeeRecipientLastName: "",
  secondPayeeRecipientSuffix: "",
};
</script>

<script setup>
import { ref, computed, watch, provide } from "vue";
import { object as yupObject, string as yupString } from "yup";
import { myIf as yupMyIf } from "~/lib/yup/myYup";
import initModalFeature, {
  modalProps,
  modalEmits,
} from "~/composables/add-update-modal";
import RegistrationName from "@/components/RegistrationName";
import { getStoreModuleContext } from "~/utils/store";
import { useI18n } from "vue-i18n";
import BanksTermsAndConditionsModal from "./BanksTermsAndConditionsModal";

const { t } = useI18n();

const instanceId = `bank-information-${instanceCount++}`;

const bankAuthTermsAndCondition = ref(false);
const acknowledgeRedemption = ref(false);
const isBanksTermsAndConditionModalVisible = ref(false);
const termsAndConditionsLinkRef = ref(null);

const customerNameStore = getStoreModuleContext("customerName");
const userProfileDetailsStore = getStoreModuleContext("userProfileDetails");

provide("termsAndConditionsLinkRef", termsAndConditionsLinkRef);

function termsAndConditionsRefFn(el) {
  termsAndConditionsLinkRef.value = el;
}

function showBanksTermsAndConditionModal() {
  isBanksTermsAndConditionModalVisible.value = true;
}

//Test data for dev and uat
const testRoutingNumber = "999999989";

const props = defineProps({
  ...modalProps,
  modelValue: {
    type: Object,
    default: () => ({
      bankMicrIdentifier: "",
      bankAccountNumber: "",
      bankAccountTypeCode: "C",
      ...defaultRegisterationNameData,
      payeeRecipientEntityCode: "N",
      bankRegistrationFormatCode: "N",
    }),
  },
  customerProfileName: {
    type: String,
  },
});

const emit = defineEmits({
  ...modalEmits,
  submitted: null,
});

const addAnotherRegestrationField = ref(false);

const registerationNameFormConfig = {
  primary: {
    firstName: {
      dataKey: "firstPayeeRecipientFirstName",
      schemaField: "individualRegisterationName.primary.firstName",
      label: "labels.firstName",
    },
    lastName: {
      dataKey: "firstPayeeRecipientLastName",
      schemaField: "individualRegisterationName.primary.lastName",
      label: "labels.lastName",
    },
    middleInitial: {
      dataKey: "firstPayeeRecipientMiddleInitial",
      schemaField: "individualRegisterationName.primary.middleInitial",
      label: "labels.middleInitial",
    },
    suffix: {
      dataKey: "firstPayeeRecipientSuffix",
      schemaField: "individualRegisterationName.primary.suffix",
      label: "labels.suffix",
    },
  },
  secondary: {
    firstName: {
      dataKey: "secondPayeeRecipientFirstName",
      schemaField: "individualRegisterationName.secondary.firstName",
      label: "labels.secondaryFirstName",
    },
    lastName: {
      dataKey: "secondPayeeRecipientLastName",
      schemaField: "individualRegisterationName.secondary.lastName",
      label: "labels.secondaryLastName",
    },
    middleInitial: {
      dataKey: "secondPayeeRecipientMiddleInitial",
      schemaField: "individualRegisterationName.secondary.middleInitial",
      label: "labels.secondaryMiddleInitial",
    },
    suffix: {
      dataKey: "secondPayeeRecipientSuffix",
      schemaField: "individualRegisterationName.secondary.suffix",
      label: "labels.secondarySuffix",
    },
  },
};

const {
  dialog,
  data,
  isLoading,
  disableSubmit,
  submitClicked,
  resetFields,
} = initModalFeature({
  props,
  emit,
  formValidationSchema: yupObject().shape({
    routingNumber: yupString()
      .tLabel("labels.routingNumber")
      .charRange("digit", 9, 9)
      .required(),
    accountNumber: yupString()
      .tLabel("labels.accountNumber")
      .when("routingNumber", {
        is: testRoutingNumber,
        then: (schema) => schema.charRange("digit", 1, 17).required(),
        otherwise: (schema) => schema.charRange("digit", 4, 17).required(),
      }),
    accountType: yupString().tLabel("labels.accountType").required(),
    registrationType: yupString().tLabel("labels.registrationType").required(),
    individualRegisterationName: yupObject().when("registrationType", {
      is: "N",
      then: (schema) =>
        schema.shape({
          primary: yupObject().shape({
            firstName: yupString()
              .tLabel("labels.firstName")
              .charRange("any", 2, 35)
              .required(),
            middleInitial: yupString(),
            lastName: yupString()
              .tLabel("labels.lastName")
              .charRange("any", 2, 35)
              .required(),
            suffix: yupString(),
          }),
          secondary: yupMyIf(
            {
              fn: "isDefault",
              options: {
                defaultValue: {
                  firstName: "",
                  lastName: "",
                  middleInitial: "",
                  suffix: "",
                },
              },
            },
            yupObject(),
            yupObject().shape({
              firstName: yupString()
                .tLabel("labels.secondaryFirstName")
                .charRange("any", 2, 35)
                .required(),
              middleInitial: yupString(),
              lastName: yupString()
                .tLabel("labels.secondaryLastName")
                .charRange("any", 2, 35)
                .required(),
              suffix: yupString(),
            })
          ),
        }),
    }),
    entityName: yupString()
      .tLabel("labels.entityName")
      .when("registrationType", {
        is: "Y",
        then: (schema) => schema.charRange("any", 2, 35).required(),
      }),
  }),
  onSubmitConfig: {
    dataloaderConfig: {
      methodName: "addBank",
      mainArgs: [computed(() => data.value)],
    },
    emitEventName: "submitted",
    emitEventData: (eventData) => {
      eventData.bankData = data.value;
      return eventData;
    },
  },
});

function registrationTypeChanged() {
  Object.assign(data.value, defaultRegisterationNameData);

  resetFields({
    "individualRegisterationName.*": null,
    entityName: null,
  });
}

const isFormValid = computed(
  () => bankAuthTermsAndCondition.value && acknowledgeRedemption.value
);

watch(
  () => customerNameStore.getters.customerName,
  (val) =>
    Object.assign(data.value, {
      firstPayeeRecipientFirstName: val?.firstName || "",
      firstPayeeRecipientLastName: val?.lastName || "",
      firstPayeeRecipientMiddleInitial: val?.middleInitial || "",
    }),
  {
    immediate: true,
  }
);
</script>
